import { render, staticRenderFns } from "./PayableRateDetailByCustomer.vue?vue&type=template&id=b18d7b14&scoped=true"
import script from "./PayableRateDetailByCustomer.vue?vue&type=script&lang=js"
export * from "./PayableRateDetailByCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18d7b14",
  null
  
)

export default component.exports